/** Amount of time (in seconds) before automatically closing an Alert */
export const ALERT_TIMEOUT = 5 * 1000;

/** VAT percentages by country */
export const VAT_AMOUNT = {
  DE: 0.19,
};
